import numeral from "numeral";
import { toNumber, injectPlaceholder, replaceAll, stripHtml } from "../helpers";
import ibsStore from "../components/Stores/IbsSurveyStore"
import { saveAs } from 'file-saver';
import { getHiddenColumns } from "./TableHelper";

export function exportData(hotTableInstance, referenceToTable, props, exportAllTableData = false) {
        if (!hotTableInstance?.current?.hotInstance || !referenceToTable) {
            return;
        }

        let hiddenCols = getHiddenColumns(props);

        let headersFullView = getTableHeaderInfo(props);
        let headersHiddenView = [];

        // Fills headersHiddenView with relevant non hidden headers
        headersFullView.forEach((header) => {
            if (!hiddenCols.includes(header.index)) {
                headersHiddenView.push(header);
            }
        });

        const headers = exportAllTableData ? headersFullView : headersHiddenView;

        let finalRowsXLSX = [];
        let finalRowsCSV = [];

        let decimalDelimeter = numeral?.localeData()?.delimiters?.decimal ?? '.';
        let thousandsDelimeter = numeral?.localeData()?.delimiters?.decimal ?? ',';
        let vaguelyANumberRegex = new RegExp(`^[0-9${thousandsDelimeter}]*(${decimalDelimeter}){1}[0-9${thousandsDelimeter}]+$`);

        for (let tableRow of referenceToTable) {
            let rowToAdd = [];

            headers.forEach((header) => {
                let cellText = "";

                if (!(tableRow[header.fieldName] === null || typeof tableRow[header.fieldName] === "undefined" || tableRow[header.fieldName] === "")) {
                    cellText = tableRow[header.fieldName].toString();

                }

                // Column specific modifications
                switch (header.fieldName) {
                    case "ReturnPct":
                        if (cellText !== "") {
                            cellText = cellText + "%";
                        }
                        break;
                    default:
                        break;
                }

                // If vaguely a number, un-localize
                if (cellText.match(vaguelyANumberRegex)) {
                    cellText = toNumber(cellText).toString();
                }


                // Moderate sanitization (remove quotations, backslashes, newline characters, and prevent commas from messing up CSV file)
                cellText = cellText.replace(/&nbsp;/g, " ");
                cellText = cellText.replace(/\"|\\/g, "");
                cellText = cellText.replace(/\n/g, "");

                let cellData = cellText;
                if (typeof cellText === "string" && parseFloat(cellText).toString() === cellText) {
                    cellData = parseFloat(cellText);
                }

                rowToAdd.push({
                    data: cellData,
                    index: header.index
                });

            });

            // Remove completely blank rows
            if (rowToAdd.map(cell => cell.data.toString()).join('') === "") {
                continue;
            }

            finalRowsCSV.push(rowToAdd.map(cell => cell.data.toString().match(/\,/g) ? `"` + cell.data.toString() + `"` : cell.data.toString()));
            finalRowsXLSX.push(rowToAdd);

        }

        let tableName = props.tableName ?? "";
        switch (tableName) {
            case "ValidationTable":
                tableName = "CostSummary";
                break;
            case "YourResults":
                tableName = "";
                break;
            case "CostSummary":
                tableName = "Asset class costs and returns";
                break;
            case "PrivateEquity":
                tableName = "Limited Partnership Details";
                break;
        }
        let year = String(ibsStore?.currentSurvey?.DataYear ?? "") ? String(ibsStore?.currentSurvey?.DataYear ?? "") + " - " : "";

        downloadXLSX(headers, finalRowsXLSX, tableName, "CEM Benchmarking " + year + tableName);
    }

    export function downloadXLSX (headers, rows, sheetName, fileName) {

        // Invalid argument check
        if (typeof headers === "undefined" || typeof rows === "undefined" || typeof fileName !== "string" || typeof sheetName !== "string" || headers === null || rows === null) {
            return;
        }
        const ExcelJS = require('exceljs');

        const workbook = new ExcelJS.Workbook();
        workbook.creator = 'CEM Benchmarking Inc.';
        workbook.lastModifiedBy = 'CEM Benchmarking Inc.';
        workbook.created = new Date();
        workbook.modified = new Date();

        const worksheet = workbook.addWorksheet(sheetName);

        // Add column names
        worksheet.columns = headers.map((header, headerIndex) => {
            let headerObj = {};

            headerObj.key = header.index.toString();
            headerObj.header = header.headerText?.toString() ?? "";

            // Remove any "- " from headers
            headerObj.header = headerObj.header.replace(/\-\ /g, "");

            // +1 so small (> 4 character) columns don't get cut off.
            headerObj.width = headerObj.header.length + 1;

            for (let i = 0; i < rows.length; i++) {
                let row = rows[i];
                if (row && row[headerIndex] && typeof row[headerIndex].data !== undefined && row[headerIndex].data?.toString()?.length > headerObj.width) {
                    headerObj.width = row[headerIndex].data?.toString()?.length;
                }
            }

            return headerObj;

        });
        rows.forEach((row, rowIndex) => {
            row.forEach((cell) => {
                // + 2 is added to row index here, worksheet indexing starts at 1, and row 1 is taken up by the headers. The first row is row 2.
                worksheet.getRow(rowIndex + 2).getCell(cell.index.toString()).value = cell.data;

                if (cell.isDefault) {
                    worksheet.getRow(rowIndex + 2).getCell(cell.index.toString()).fill = {
                        type: "pattern",
                        pattern: "solid",
                        fgColor: { argb: 'FFEAF0F6' }
                    };
                }


            });
        });

        workbook.xlsx.writeBuffer().then((data) => {
            const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
            saveAs(blob, fileName + ".xlsx");
        });

}


export function getTableHeaderInfo(props) {
    if (!props.nestedHeaders) {
        return [];
    }

    let headersTemp = props.nestedHeaders.map(headerArray => {
        return headerArray.map((header, index) => {

            let objToAdd = {};

            let trueHeaderText = header;

            if (typeof (header) === 'string') {
                trueHeaderText = injectPlaceholder(header);
                trueHeaderText = replaceAll(stripHtml(trueHeaderText), "  ", " ");
            }

            objToAdd.index = index;
            objToAdd.headerText = trueHeaderText;
            objToAdd.fieldName = props.columns ? props.columns[index]?.data : null;
            objToAdd.colWidth = props.colWidths ? props.colWidths[index] : null;
            objToAdd.helpText = props.helpText ? props.helpText[index] : null;

            if (typeof objToAdd.colWidth === "string") {
                objToAdd.colWidth = objToAdd.colWidth.toLowerCase().replaceAll("px", "");
                objToAdd.colWidth = parseInt(objToAdd.colWidth, 10);
            }

            return objToAdd;
        })
    })

    let headers = [];
    headersTemp.forEach((array) => {
        headers = headers.concat(array);
    });

    return headers;

}



export function exportMandateData(hotTableInstance, referenceToTable, props, exportAllTableData = false) {
    let mandateType = ibsStore?.checkMandateLevel ?? 1;
    let columnsToHideXLSX = ["MandateID"];
    let additionalMandateColumns = [{ index: -1, fieldName: "MandateID", colWidth: 45, headerText: "Mandate ID" }];

    if (!hotTableInstance?.current?.hotInstance || !referenceToTable) {
        return;
    }

    let hiddenCols = getHiddenColumns(props);

    let headersFullView = getTableHeaderInfo(props);
    let headersHiddenView = [];

    // Fills headersHiddenView with relevant non hidden headers
    headersFullView.forEach((header) => {
        if (!hiddenCols.includes(header.index)) {
            headersHiddenView.push(header);
        }
    });

    // Inject analyst only columns
    if ((mandateType === "2" || mandateType === 2 || mandateType === "1" || mandateType === 1)) {
        headersFullView = additionalMandateColumns.concat(headersFullView);
        headersHiddenView = additionalMandateColumns.concat(headersHiddenView);
        let count = 0;
        headersFullView.forEach((elem) => { elem.index = count; count++; });
        count = 0;
        headersHiddenView.forEach((elem) => { elem.index = count; count++; });
    }

    headersFullView.forEach((elem) => { if (columnsToHideXLSX.includes(elem.fieldName)) { elem.hiddenColumn = true; } });
    headersHiddenView.forEach((elem) => { if (columnsToHideXLSX.includes(elem.fieldName)) { elem.hiddenColumn = true; } });

    const headers = exportAllTableData ? headersFullView : headersHiddenView;

    let finalRowsXLSX = [];
    let finalRowsCSV = [];

    let decimalDelimeter = numeral?.localeData()?.delimiters?.decimal ?? '.';
    let thousandsDelimeter = numeral?.localeData()?.delimiters?.decimal ?? ',';
    let vaguelyANumberRegex = new RegExp(`^[0-9${thousandsDelimeter}]*(${decimalDelimeter}){1}[0-9${thousandsDelimeter}]+$`);

    for (let tableRow of referenceToTable) {
        let rowToAdd = [];
        let defaultsForRow = [];
        let rowMarkedForHighlighting = false;

        if (tableRow["RowID"]) {
            defaultsForRow = ibsStore.defaultCoordinates.filter(def => def.rowID === tableRow["RowID"]);
        }
        if ((mandateType === "2" || mandateType === 2 || mandateType === "1" || mandateType === 1) && tableRow?.AssetClassCategoryName?.toLowerCase() !== "total" && (tableRow?.AssetClassCategoryName?.length > 0 && !(tableRow?.AssetClassNameReal?.length > 0))) {
            rowMarkedForHighlighting = true;
        }

        headers.forEach((header) => {
            let cellText = "";
            let isDefault = false;

            if (!(tableRow[header.fieldName] === null || typeof tableRow[header.fieldName] === "undefined" || tableRow[header.fieldName] === "")) {
                cellText = tableRow[header.fieldName].toString();

            }

            //Add default for field if it exists
            if (defaultsForRow && typeof defaultsForRow !== "undefined" && defaultsForRow !== null) {
                let theDefault = defaultsForRow.filter(item => item.qName.toLowerCase() === header.fieldName.toLowerCase())
                if (typeof theDefault !== "undefined" && theDefault.length > 0 && typeof theDefault[0] !== "undefined" && theDefault[0]?.value !== null) {
                    let theValue = theDefault[0].value.toString();
                    if (theValue !== "null" && theValue !== "undefined" && theValue.toLowerCase() !== "n/a") {
                        cellText = theValue;
                        isDefault = true;
                    }
                }
            }
            // Column specific modifications
            switch (header.fieldName) {
                case "ReturnPct":
                    if (cellText !== "") {
                        cellText = cellText + "%";
                    }
                    break;
                default:
                    break;
            }

            // If vaguely a number, un-localize
            if (cellText.match(vaguelyANumberRegex)) {
                cellText = toNumber(cellText).toString();
            }

            // Please, HTML go away
            // Replace any HTML icons in assets table category rows
            cellText = cellText.replace(/\<i(.*)/, "");

            // Moderate sanitization (remove quotations, backslashes, newline characters, and prevent commas from messing up CSV file)
            cellText = cellText.replace(/&nbsp;/g, " ");
            cellText = cellText.replace(/\"|\\/g, "");
            cellText = cellText.replace(/\n/g, "");

            let cellData = cellText;
            if (typeof cellText === "string" && parseFloat(cellText).toString() === cellText) {
                cellData = parseFloat(cellText);
            }

            rowToAdd.push({
                data: cellData,
                index: header.index,
                isDefault: isDefault,
                markedForHighlighting: rowMarkedForHighlighting
            });

        });

        // Remove completely blank rows
        if (rowToAdd.map(cell => cell.data.toString()).join('') === "") {
            continue;
        }

        finalRowsCSV.push(rowToAdd.map(cell => cell.data.toString().match(/\,/g) ? `"` + cell.data.toString() + `"` : cell.data.toString()));
        finalRowsXLSX.push(rowToAdd);
    }

    let tableName = "Manager mandate costs and returns";
    if (mandateType === "2" || mandateType === 2) {
        tableName = "Asset class and manager mandate";
    }
    if (mandateType === "0" || mandateType === 0) {
        tableName = "Asset class costs and returns";
    }

    let year = String(ibsStore?.currentSurvey?.DataYear ?? "") ? String(ibsStore?.currentSurvey?.DataYear ?? "") + " - " : "";

    downloadMandateXLSX(headers, finalRowsXLSX, tableName, "CEM Benchmarking " + year + tableName);

}


export function downloadMandateXLSX (headers, rows, sheetName, fileName) {
    // Invalid argument check
    if (typeof headers === "undefined" || typeof rows === "undefined" || typeof fileName !== "string" || typeof sheetName !== "string" || headers === null || rows === null) {
        return;
    }
    const ExcelJS = require('exceljs');
    const workbook = new ExcelJS.Workbook();
    workbook.creator = 'CEM Benchmarking Inc.';
    workbook.lastModifiedBy = 'CEM Benchmarking Inc.';
    workbook.created = new Date();
    workbook.modified = new Date();

    const worksheet = workbook.addWorksheet(sheetName);

    // Add column names
    worksheet.columns = headers.map((header, headerIndex) => {
        let headerObj = {};

        headerObj.key = header.index.toString();
        headerObj.header = header.headerText?.toString() ?? "";

        // Remove any "- " from headers
        headerObj.header = headerObj.header.replace(/\-\ /g, "");

        headerObj.width = headerObj.header.length + 1;

        for (let i = 0; i < rows.length; i++) {
            let row = rows[i];
            if (row && row[headerIndex] && typeof row[headerIndex].data !== undefined && row[headerIndex].data?.toString()?.length > headerObj.width) {
                headerObj.width = row[headerIndex].data?.toString()?.length;
            }
        }

        if (header?.hiddenColumn === true) {
            headerObj.hidden = true;
        }

        return headerObj;

    });
    rows.forEach((row, rowIndex) => {
        row.forEach((cell) => {
            // + 2 is added to row index here, worksheet indexing starts at 1, and row 1 is taken up by the headers. The first row is row 2.
            worksheet.getRow(rowIndex + 2).getCell(cell.index.toString()).value = cell.data;

            if (cell.isDefault && !cell.markedForHighlighting) {
                worksheet.getRow(rowIndex + 2).getCell(cell.index.toString()).fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: 'FFEAF0F6' }
                };
            }
            if (cell.markedForHighlighting) {
                worksheet.getRow(rowIndex + 2).getCell(cell.index.toString()).fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: 'FFE2E2E2' }
                };
            }

        });
    });

    workbook.xlsx.writeBuffer().then((data) => {
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
        saveAs(blob, fileName + ".xlsx");
    });

}
